import { useContext } from 'react';
import { WalletsContext } from '@providers/WalletsProvider';

const useWallets = () => useContext(WalletsContext);

export default useWallets;
